import api from '@/api/API';
import { AccountPricePlan } from '@/types';
import eventBus from '@/messaging/event-bus';
import { PricePlanStarted } from '@/messaging/events';

export default {
  start(
    clientId: string, pricePlanId: string, paymentMethodId: string,
  ): Promise<AccountPricePlan> {
    return api
      .post(`clients/${clientId}/price-plans`, {
        pricePlanId,
        paymentMethodId,
      }).then((response) => {
        const accountPricePlan = (response as unknown as AccountPricePlan);
        eventBus.$emit(PricePlanStarted.eventName, accountPricePlan);
        return accountPricePlan;
      });
  },
};
